import React from 'react';
import Radium from 'radium';

import Styles from './ProjectDetailsHeader.styles';

const ProjectDetailsHeader = props => <div style={Styles.headline}>{props.text}</div>;

export default Radium(ProjectDetailsHeader);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetailsHeader/ProjectDetailsHeader.js